import { useNavigate } from "react-router-dom";
import { Card } from "react-bootstrap"

const SiteMapCard = ({ data }) => {

  const navigate = useNavigate();

  const handleNavigate = (path) => {
    if (path === "" || path === "#") return;

    // external link
    if (path.startsWith("http")) {
      // opne in a new tab
      window.open(path, "_blank", "noopener,noreferrer");
      return;
    }

    navigate(path);
  }

  const handleKeyDown = (e, path) => {
    // Key "Enter" to direct
    if (e.keyCode === 13) {
      if (path) {
        handleNavigate(path);
      }
    }
  }

  return (
    <Card className="mb-5">
      <Card.Body>
        <Card.Text>
          {data.map((item, index) => (
            <div className="m-4" >
              <a tabIndex={0} onKeyDown={(e) => handleKeyDown(e, item.link)} onClick={() => handleNavigate(item.link)} key={index}>{item.title}</a>
              {item.subTitles && item.subTitles.length > 0 ?
                <ul className="mt-3">
                  {item.subTitles.map((subItem, subIndex) => (
                    <li key={subIndex}>
                      {subItem.title}
                    </li>
                  ))}
                </ul> : null}
            </div>
          ))}
        </Card.Text>
      </Card.Body>
    </Card>
  )
}

export default SiteMapCard;